import React, { useReducer } from "react";
import { useSelector } from "react-redux";
import {
  STATE_CULTURE,
  STATE_CURRENCY,
  STATE_POS_ID,
  STATE_SALE_ID,
} from "./Actions/cookiesActions";
//import Cookies from "cookies-js";
export const AppContext = React.createContext();

export const THEME = "theme";
export const SET_THEME = "set_theme";
export const TOGGLE_TERMS = "toggle_terms";
export const TOGGLE_OPTIN = "toggle_optin";
export const SET_PAYMENT_METHOD = "set_payment_method";
export const CLEAR_PAYMENT_METHOD = "clear_payment_method";
export const SET_IDENTIFIER = "set_identifier";
export const ADD_ARTICLE_DATA = "add_article_data";
export const SET_DELIVERY_METHOD = "set_delivery_method";
export const ADD_CULTURES = "add_cultures";
export const ADD_CURRENCIES = "add_currencies";
export const ADD_COMMIT = "add_commit";
export const ADD_GIFT_CERTIFICATE = "add_gift_certificate";

const getReduxState = (state) => ({
  auth: state.oidc.user !== null && !state.oidc.user.expired,
  config: state.config,
  culture: state.cookies[STATE_CULTURE],
  currency: state.cookies[STATE_CURRENCY],
  language: state.language,
  message: state.message,
  posId: state.cookies[STATE_POS_ID],
  saleId: state.cookies[STATE_SALE_ID],
  version: state.state.version,
});

const getTheme = () => {
  return "light";

  //Note: Disabled theme for now, as this is not possible to change in checkout + no way to make cusomtizations for dark theme = it will look bad /robe
  /*
              const savedTheme = Cookies.get(THEME);
            
              if (savedTheme === undefined) {
                Cookies.set(THEME, "light");
                return "light";
              }
              return savedTheme;
              */
};

const initialState = (optIn) => ({
  paymentMethodId: "",
  theme: getTheme(),
  showTerms: false,
  identifier: "",
  hasOptedIn: optIn.enabled && optIn.isSoft ? true : false,
  articles: [],
  deliveryMethod: null,
  cultures: [],
  currencies: [],
  commitData: null,
  giftCertificate: null,
});

const reducer = (state, action) => {
  switch (action.type) {
    case CLEAR_PAYMENT_METHOD:
      return { ...state, paymentMethodId: "" };
    case SET_IDENTIFIER:
      return { ...state, identifier: action.payload };
    case SET_PAYMENT_METHOD:
      return { ...state, paymentMethodId: action.payload };
    case SET_THEME:
      return { ...state, theme: action.payload };
    case TOGGLE_TERMS:
      return { ...state, showTerms: !state.showTerms };
    case TOGGLE_OPTIN:
      return { ...state, hasOptedIn: !state.hasOptedIn };
    case ADD_ARTICLE_DATA:
      return { ...state, articles: action.payload };
    case SET_DELIVERY_METHOD:
      return { ...state, deliveryMethod: action.payload };
    case ADD_CULTURES:
      return { ...state, cultures: action.payload };
    case ADD_CURRENCIES:
      return { ...state, currencies: action.payload };
    case ADD_COMMIT:
      return { ...state, commitData: action.payload };
    case ADD_GIFT_CERTIFICATE:
      return { ...state, giftCertificate: action.payload };
    default:
      throw new Error(`wrong action type: ${action.type}`);
  }
};

const ContextProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState(props.optIn));
  const rdxState = useSelector((state) => getReduxState(state));

  return (
    <AppContext.Provider
      value={{
        state: {
          ...state,
          ...rdxState,
          userManager: props.userManager,
        },
        dispatch,
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default ContextProvider;
